// Step labels - single source of truth (no component imports to avoid circular deps)
export const STEP_LABELS = [
  'Upload Files',
  'Set Mapping',
  'Link Accounts',
  'Link ISIN/Symbol',
  'Link OTC',
  'Review & Upload',
  'Positions Monitoring',
] as const;

export const getStepLabel = (stepIndex: number): string => {
  // API uses 1-indexed steps
  return STEP_LABELS[stepIndex - 1] || `⚠️ Unknown step ${stepIndex}`;
};
